import styled, { css } from 'styled-components';

export const LayoutPage = styled.section`
  padding-top: 1.5rem;
  height: 100vh;
  @media (max-width: 900px) {
    padding-top: 3rem;
  }
  @media (max-width: 925px) {
    padding-top: 4rem;
    height: 100%;
  }

  .page {
    width: calc(100% - 9rem);
    margin-left: 9rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    @media (max-width: 900px) {
      height: 100%;
      width: 100%;
      margin-left: 0;
    }
    ${({ sideBar }) =>
      sideBar &&
      css`
        filter: blur(4px);
      `}
  }

  .top-tags {
    // bottom: auto;
    // top: 3.125rem;
    @media (max-width: 695px) {
      // top: 2.5rem;
    }
  }

  .tags {
    color: #3bcfe3;
    opacity: 0.3;
    margin-left: 2.5rem;
    font-size: 18px;
    font-family: 'La Belle Aurore', cursive;

    @media (max-width: 900px) {
      margin-left: 1.7rem;
    }
    @media (max-width: 500px) {
      margin-left: 0.75rem;
    }
  }

  .bottom-tags {
  }

  .bottom-tag-html {
    margin-left: -0.2px;
    @media (max-width: 500px) {
      margin-top: -20px;
    }
  }
`;
